<template>
    <div class="content">
        <h1>IMPRESSUM</h1>
        <h2>aixtrologics - kosmologische dienstleistungen</h2>
        <p>
            Gesch&auml;ftsf&uuml;hrer: Guido Buchholz<br>
            Anschrift: Oststr. 15, 52222 Stolberg<br>
            <!--Telefon: +49 2402 9056291<br>-->
            E-Mail: <a href="mailto:info@aixtrologics.com" @click="emitLogData('impressum', 'mailtoLink')">info@aixtrologics.com</a><br>
            Internet: <router-link to="/">www.aixtrologics.com</router-link>
        </p>
        <p>
            Angemeldetes Gewerbe nach<br>
            § 14 GewO, § 55c Gewerbeordnung<br>
            bei der Stadt Stolberg (Rhld.)<br>
            Gemeindekennzahl 05334032
        </p>
        <h2>Haftungshinweis:</h2>
        <p>
            Trotz sorgf&auml;ltiger inhaltlicher Kontrolle &uuml;bernimmt aixtrologics keine Haftung f&uuml;r die Inhalte 
            externer Links. F&uuml;r den Inhalt verlinkter Seiten sind ausschlie&szlig;lich deren Betreiber verantwortlich.
        </p>
    </div>
</template>

<script>
export default {
    name: 'impressum',
    methods: {
        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('impressum', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('impressum', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    h2 {
        margin-top: 30px;
    }
</style>
